import User from 'auth/User';
import { PAGES_ENUM, PERMISSION_ENUM } from 'routes/enums';
import permissionService from 'routes/permissionService';
import { dashboard, triage } from 'routes/routePaths';

interface RouteProps {
  route: string;
  isExternal: boolean;
}

const homePage = (user: User): RouteProps => {
  if (permissionService.hasPermission(user, PAGES_ENUM.APPLICATION_FLOW, PERMISSION_ENUM.ADMINISTRATIVE)) {
    return { route: triage, isExternal: false };
  }
  if (permissionService.hasAnyPermission(user, PAGES_ENUM.APPLICATION_FLOW)) {
    return { route: process.env.REACT_APP_CASES_URL || '', isExternal: true };
  }
  return { route: dashboard, isExternal: false };
};

export const navigateExternal = (path: string = '') => {
  window.location.replace(path);
};

export default homePage;
